import React from "react"
import Ingredient from "./Ingredient"
import { addMeal,addMealIngredient,renameMeal,deleteMeal,scopeMeal,setMealType } from "../service"
import { MEAL_TYPES } from "../mealTypes"

export default function Meal({id,label,expanded,ingredients,inScope,justMade,mealType,updateMeals,index}){
  const [showDetails,setExpanded] = React.useState(expanded)
  let [editMode,setEditMode] = React.useState(justMade)
  const mealIndex = index

  function addRemoveFromPlan(){
    updateMeals((prevMeals) => {
      //Invert Meal's "In Scope" property
      const newMealList = prevMeals.map(
        (meal,i)=> i === mealIndex ? {...meal, inScope : !prevMeals[i].inScope} : meal
      )
      return newMealList
    })
    updateMeals((prevMeals) => {
      //Untick all a meal's ingredients when changing adding or removing it from the meal plan
      //and prompt the server to set the scope of this meal
      const newMealList = prevMeals.map(
        (meal,i)=> i === mealIndex ? {...meal, ingredients : meal.ingredients.map((ingredient) => {return {...ingredient,ticked:false}})} : meal
      )
      scopeMeal(prevMeals[mealIndex].id,prevMeals[mealIndex].inScope)
      return newMealList
    })

  }

  function changeMealType(type){
    if(type === mealType) return
    updateMeals((prevMeals) => {
      const newMealList = prevMeals.map(
        (meal,i) => i === mealIndex ? {...meal, mealType: type} : meal
      )
      setMealType(prevMeals[mealIndex].id, type)
      return newMealList
    })
  }

  function showHide(){
    setExpanded((prevExpanded) => !prevExpanded)
  }

  function enterEditMode(){
    setEditMode(previousEditMode => !previousEditMode)
  }

  function handleEdit(event,setEditMode){
    if (event.key === "Enter") {
      setEditMode(false)
      if (event.target.value === ""){
        //An Empty Meal Name Deletes The whole meal
        updateMeals((prevMeals) => {
          deleteMeal(prevMeals[mealIndex].id)
          const newMealList = prevMeals.filter((listItem,j) => j !== mealIndex)
          return newMealList
        }
        )
      }
      else{
        //Any other meal name saves it
        updateMeals(prevMeals => {
          renameMeal(prevMeals[mealIndex].id,event.target.value)
          const newMealList = prevMeals.map((meal,i) => 
          {
            return i !== mealIndex ? meal : {...meal, label: event.target.value }
          })
          return newMealList
        }
        )
      }
    }
  }

  function addIngedient(){
    //Update UI
    updateMeals(prevMeals => {
      const newMealList = prevMeals.map((meal,i) => 
      {
        return i !== mealIndex ? meal : {...meal, ingredients: [{id: undefined, label:"new",stocked:false, category:0},...meal.ingredients] }
      })
      return newMealList
    }
    )
    //update state with new UUID once the server responds
    addMealIngredient(id,"new").then((data) => {
      updateMeals((prevMeals) => {
        const newMealList = prevMeals.map((meal,i) => 
          {
            return i !== mealIndex ? meal : {...meal, ingredients: meal.ingredients.map((ingredient) =>
            {
              return {...ingredient, id : ingredient.id === undefined ? data.id : ingredient.id}
            }
          )}
          })
          return newMealList
      })
    })
  }

  let labelDiv = editMode || justMade ?
    <input className="meal--label"
    placeholder={label}
    onKeyUp={(e) => handleEdit(e,setEditMode)}
    autoFocus/>
  :
    <div className="meal--label"
    onClick={enterEditMode}>{label}</div>

  const details = (<div className="meal--details">
    <button className="mealIngredient--button" onClick={addIngedient}>
      +
    </button>
    <div className="meal--type">
      <h5>Type</h5>
      <div className="meal--typeButtons">
        {MEAL_TYPES.map((type) => (
          <button key={type}
            className={type === mealType ? "meal--typeButton meal--typeButton--active" : "meal--typeButton"}
            onClick={() => changeMealType(type)}>
            {type}
          </button>
        ))}
      </div>
    </div>
      <div className="meal--headers">
        <h5>Stocked?</h5>
      </div>
    {ingredients.map((ingredient,ingredientIndex) => 
      <Ingredient
        id={ingredient.id}
        mealID={id}
        label={ingredient.label}
        stocked={ingredient.stocked}
        justMade={ingredientIndex===0 && ingredient.label === "new"}
        updateMeals={updateMeals}
        ingredientIndex={ingredientIndex}
        mealIndex={mealIndex}
        key={ingredientIndex}
      />
    )}
  </div>)
  console.log("Meal Render Called")
  return(
    <div className={inScope ? "meal--inscope" : "meal--outofscope" }>
      <div className="meal--header">
      <button className="meal--showHide" onClick={showHide}>
        {showDetails ? "v" : ">" }
      </button>
      {labelDiv}
      <button className={inScope ? "meal--remove" : "meal--add" } onClick={addRemoveFromPlan}>
        {inScope ? "Shopping -" : "Shopping +"}
      </button>
      </div>

      {showDetails && details}
    </div>
  )
}